import { render, staticRenderFns } from "./BlueCardTemplate.vue?vue&type=template&id=331a2f1e"
import script from "./BlueCardTemplate.vue?vue&type=script&lang=js"
export * from "./BlueCardTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports